/**
 * Pnr references Group
 * @param fb : FormBuilder
 */
export function pnrReferencesGroup (fb: any):any {
    return pnrReferences(fb);
}

export function pnrReferences (fb: any): any {
    return fb.group({
        code: [''],
        provider: ['']
    });
}
